import tippy, { type Instance as TippyInstance } from 'tippy.js';
import { ReactRenderer } from '@tiptap/react';
import { type MentionOptions } from '@tiptap/extension-mention';

import VariablesList from 'src/pages/landlord/playbooks/components/form/playbook-template-message/VariablesList';

/**
 * Uses the Tiptap editor. For more information, see https://tiptap.dev/
 */
export const getSuggestion = (items: string[]): MentionOptions['suggestion'] => ({
    char: '{',
    allowedPrefixes: null,

    items: () => items,

    render: () => {
        let component: ReactRenderer;
        let popup: TippyInstance[];

        return {
            onStart: (props) => {
                component = new ReactRenderer(VariablesList, {
                    props,
                    editor: props.editor,
                });

                if (!props.clientRect) {
                    return;
                }

                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect as any,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                });
            },

            onUpdate(props) {
                component.updateProps(props);

                if (!props.clientRect) {
                    return;
                }

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect as any,
                });
            },

            onExit() {
                popup[0].destroy();
                component.destroy();
            },
        };
    },
});